import RegisterSecond from "./RegisterSecond";

export default RegisterSecond;
